"use client";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDotCircle } from "@fortawesome/free-solid-svg-icons";
import { Card, CardContent } from "@packages/ui/src/components/shadcn/card";
import ContainerGlob from "../../../../componentsGLob/ContainerGlob";

export default function WagglePointsSection() {
  const { t } = useTranslation("buzzCard");
  const section = t("wagglePointsSection", { returnObjects: true }) as {
    title: string;
    description: string;
    points: { label: string; points: string }[];
  };

  return (
    <section className="py-12 md:py-16" id="punti">
      <ContainerGlob>
        <h2 className="text-3xl font-bold mb-4 text-center">{section.title}</h2>
        <p className="text-lg text-center text-muted-foreground mb-8 max-w-2xl mx-auto">
          {section.description}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {section.points.map((item, idx) => (
            <Card key={idx} className="shadow-sm hover:shadow-md transition">
              <CardContent className="p-6 flex items-start gap-4">
                <FontAwesomeIcon
                  icon={faDotCircle}
                  className="text-yellow-500 mt-1"
                  size="lg"
                />
                <div className="flex flex-col">
                  <p className="font-semibold text-base">{item.label}</p>
                  <span className="text-sm text-white bg-yellow-500 px-2 py-0.5 rounded w-fit mt-3">
                    {item.points}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </ContainerGlob>
    </section>
  );
}
